import React from 'react';
import PropTypes from 'prop-types';
import './index.module.css';

const Input = ({
  label,
  id,
  name,
  value,
  onChange,
  readonly = false,
  type = 'text',
  placeholder = '',
  maxLength,
  className = '',
  required = false,
  error,
  ...rest
}) => {
  const containerClasses = [
    'input',
    error && 'input--error'
  ].filter(Boolean).join(' ');

  const inputClasses = [
    'input__ctrl',
    readonly && 'input__ctrl--readonly',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClasses}>
      {label && (
        <label className="input__label" htmlFor={id}>
          {label}
        </label>
      )}
      <input
        className={inputClasses}
        readOnly={readonly}
        type={type}
        name={name}
        id={id}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        maxLength={maxLength}
        required={required}
        {...rest}
      />
      {error && (
        <div className="input__error-container">
          <div className="input__error">
            <p>{error}</p>
          </div>
        </div>
      )}
    </div>
  );
};

Input.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  readonly: PropTypes.bool,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  className: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.string
};

export default Input;
